<template>
	<div>
		<ld-popup
			:id="idPopupEditarPrazo"
			class="popup-editar-prazo"
			:fullscreen="true"
			:active.sync="activePopup"
			:button-close-hidden="true"
			:closed="funcaoFechar"
			:disabledBackgoundClose="true"
		>
			<div class="popup-editar-content">
				<div class="popup-editar-header flex flex-wrap justify-between w-full pb-5">
					<div class="title-container flex items-start flex-1">
						<div class="content-title flex-col items-start justify-start mr-5 mb-2">
							<h2 class="title">Editar prazo</h2>
							<div
								v-if="empresa && empresa.nome"
								class="flex items-center"
							>
								<h4 class="text-sm">{{ empresa.nome }}</h4>
							</div>
						</div>

						<vs-alert
							v-if="diasAlerta != null && prazo && prazo.situacao == 'EM_ALERTA' && !prazo.finalizado"
							class="em-alerta w-auto h-auto mr-3"
							color="warning"
							active="true"
						>
							{{ diasAlerta == 0 ? 'Em alerta - Último dia' : ''}}
							{{ diasAlerta == 1 ? 'Em alerta - Falta ' + diasAlerta + ' dia' : ''}}
							{{ diasAlerta > 1 ? 'Em alerta - Faltam ' + diasAlerta + ' dias' : ''}}
						</vs-alert>

						<vs-alert
							v-if="prazo && prazo.situacao == 'ATRASADO' && !prazo.finalizado"
							class="w-auto h-auto mr-3"
							color="danger"
							active="true"
						>
							Atrasado
						</vs-alert>
					</div>

					<div class="buttons-actions-container flex justify-end">

						<ld-button
							v-if="prazo && !isPrazoPerdido && !prazo.ciente && !prazo.desativado && !prazo.finalizado && (($permissions.can('prazomodificar_ciente') || $permissions.can('autenticadosuperuser')))"
							color="success"
							class="mr-3"
							@click="popupDarCienciaPrazo = true"
						>
							Dar ciência
						</ld-button>

						<ld-button
							v-if="prazo  && prazo.situacao != 'PERDIDO' && prazo.ciente && !prazo.desativado && prazo.cumprido && !prazo.finalizado && (($permissions.can('prazomodificar_situacao_finalizado')) || $permissions.can('autenticadosuperuser'))"
							color="success"
							class="mr-3"
							@click="popupFinalizarPrazo = true"
						>
							Finalizar
						</ld-button>

						<ld-button
							v-if="prazo && !isPrazoPerdido && !prazo.desativado && (prazo.finalizado || prazo.cumprido) && ($permissions.can('prazomodificar_situacao') || $permissions.can('autenticadosuperuser'))"
							color="primary"
							class="mr-3"
							@click="popupReabrirPrazo = true"
						>
							Reabrir
						</ld-button>

						<ld-button
							v-if="prazo && prazo.situacao != 'PERDIDO' && prazo.ciente && !prazo.desativado && !prazo.cumprido && !prazo.finalizado && (($permissions.can('prazomodificar_situacao_cumprido')) || $permissions.can('autenticadosuperuser'))"
							color="primary"
							class="mr-3"
							@click="popupCumprirPrazo = true"
						>
							Dar como cumprido
						</ld-button>

						<ld-button
							v-if="prazo && !isPrazoPerdido && !prazo.finalizado && ($permissions.can('prazomodificar_desativado') || $permissions.can('autenticadosuperuser'))"
							:color="
								prazo && prazo.desativado ? 'success' : 'danger'
							"
							@click="popupDesativarPrazo = true"
						>
							{{
								prazo && prazo.desativado
									? "Ativar"
									: "Desativar"
							}}
						</ld-button>

					</div>

					<ld-button
						icon-pack="feather"
						icon="icon-x"
						size="large"
						color="dark"
						type="flat"
						class="header-button-close ml-4"
						@click="() => {
						if((prazo && !isPrazoPerdido && !prazo.finalizado) && ($permissions.can('prazomodificar') || $permissions.can('autenticadosuperuser'))) {
							popupCancelarEdicao = true
						} else if ((prazo && (prazo.finalizado || isPrazoPerdido)) || (!$permissions.can('prazomodificar') && !$permissions.can('autenticadosuperuser'))) {
							if (prazo && prazo.anexos && prazo.anexos.length) {
								popupAnexosExistentesSair = true;
							} else {
								cancelarEdicao();
							}
						}
					}"
					></ld-button>
				</div>

				<div class="prazo-editar-content flex justify-between w-full mr-5">
					<vx-card class="form-container">
						<form v-if="prazo" class="form-editar-prazo" :id="idFormEditarPrazo">

							<div
								v-if="($permissions.can('prazoadicionar') && $permissions.can('prazomodificar')) || $permissions.can('autenticadosuperuser')"
								class="flex justify-end w-full relative">
								<ld-button
									type="border"
									@click="popupDuplicarPrazo = true"
								>
									Duplicar prazo
								</ld-button>
							</div>

							<!-- GENERAL -->
							<geral
								:parent="'#' + idPopupEditarPrazo"
								v-if="activePopup"
								:titulo.sync="prazo.titulo"
								:acao.sync="prazo.acao"
								:responsavel.sync="responsavelPk"
								:supervisor.sync="supervisorPk"
								:prioridade.sync="prazo.prioridade"
								:ciencia.sync="prazo.ciente"
								:descricao.sync="prazo.descricao"
								:edicao="true"
								:prazoDesativado.sync="prazo.desativado"
								:prazoFinalizado.sync="prazo.finalizado"
								:prazoPerdido.sync="isPrazoPerdido"
							/>

							<!-- Date -->
							<datas
								:dateInicio.sync="prazo.dataInicio"
								:dateFim.sync="prazo.dataFim"
								:quantidadeDias.sync="prazo.quantidadeDias"
								:tipoCalculo.sync="prazo.diasUteis"
								:edicao="true"
								:prazoDesativado.sync="prazo.desativado"
								:prazoFinalizado.sync="prazo.finalizado"
								:prazoPerdido.sync="isPrazoPerdido"
							/>

							<!-- Nome das partes -->
							<partes
								:prazoFinalizado.sync="prazo.finalizado"
								:prazoDesativado.sync="prazo.desativado"
								:prazoPerdido.sync="isPrazoPerdido"
								:edicao="true"
								:partes.sync="prazo.partes"
							/>

							<div class="flex justify-end py-5">
								<ld-button
									v-if="(prazo && !isPrazoPerdido && !prazo.finalizado) && ($permissions.can('prazomodificar') || $permissions.can('autenticadosuperuser'))"
									type="border"
									class="mr-4"
									@click="popupCancelarEdicao = true"
								>
									Cancelar
								</ld-button>
								<ld-button
									v-if="(prazo && !isPrazoPerdido && !prazo.finalizado) && ($permissions.can('prazomodificar') || $permissions.can('autenticadosuperuser'))"
									@click="() => {
										if (prazo && prazo.anexos && prazo.anexos.length) {
											popupAnexosExistentesSalvarAlteracao = true;
										} else {
											editarPrazo();
										}
									}">
									Salvar alterações
								</ld-button>
								<ld-button
									v-if="(prazo && (prazo.finalizado || isPrazoPerdido)) || (!$permissions.can('prazomodificar') && !$permissions.can('autenticadosuperuser'))"
									@click="() => {
										if (prazo && prazo.anexos && prazo.anexos.length) {
											popupAnexosExistentesSair = true;
										} else {
											cancelarEdicao();
										}
									}"
								>
									Fechar
								</ld-button>
							</div>
						</form>
					</vx-card>

					<historico
						v-if="registros && ($permissions.can('timelinevisualizar') || $permissions.can('autenticadosuperuser'))"
						class="ml-10"
						:prazoPk="prazoPk"
						:prazo="prazo"
						:prazoPerdido.sync="isPrazoPerdido"
						:atualizar.sync="atualizarHistorico"
						:initialData="registros"
					/>

				</div>

			</div>


			<ld-popup
				title="Anexos"
				:active.sync="popupAnexosExistentesSalvarAlteracao"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja salvar as alterações do prazo?
					<strong><i>Existe anexos que não foram enviados e serão perdidos</i></strong>.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							buttonType="submit"
							class="w-20 mr-4"
							color="danger"
							type="filled"
							@click="editarPrazo"
							>Continuar</ld-button
						>

						<ld-button
							class="w-15"
							color="dark"
							type="flat"
							@click="popupAnexosExistentesSalvarAlteracao = false"
							>Voltar</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Anexos"
				:active.sync="popupAnexosExistentesSair"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja sair do prazo?
					<strong><i>Existe anexos que não foram enviados e serão perdidos</i></strong>.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							buttonType="submit"
							class="w-20 mr-4"
							color="danger"
							type="filled"
							@click="cancelarEdicao"
							>Sair</ld-button
						>

						<ld-button
							class="w-15"
							color="dark"
							type="flat"
							@click="popupAnexosExistentesSair = false"
							>Voltar</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Cancelar edição?"
				:active.sync="popupCancelarEdicao"
				:button-close-hidden="true"
			>
				<p v-if="prazo">
					Tem certeza que deseja cancelar a edição do prazo?
					<strong><i>{{ prazo && prazo.anexos && prazo.anexos.length ? 'Existe anexos não enviados, ' : ''}}</i></strong>se
					cancelar, {{ prazo && prazo.anexos && prazo.anexos.length ? 'os anexos e ' : ''}}todos os novos dados inseridos serão perdidos.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							buttonType="submit"
							class="w-20 mr-4"
							color="danger"
							type="filled"
							@click="cancelarEdicao"
							>Cancelar edição</ld-button
						>

						<ld-button
							class="w-15"
							color="dark"
							type="flat"
							@click="popupCancelarEdicao = false"
							>Voltar</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				:title="
					prazo && !prazo.desativado
						? 'Prazo ativado'
						: 'Prazo desativado'
				"
				:active.sync="popupPrazoDesativado"
				:button-close-hidden="true"
				:disabledBackgoundClose="true"
			>
				<p>
					O prazo foi
					{{
						prazo && !prazo.desativado ? " ativado" : " desativado"
					}}.
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<vs-button
							class="w-64 mr-4"
							color="primary"
							type="flat"
							@click="desativacaoFinalizada"
							>Ir para prazos</vs-button
						>

						<vs-button
							class="w-64"
							color="primary"
							type="filled"
							@click="continuarEditando"
							>Continuar editando</vs-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Prazo alterado"
				:active.sync="popupPrazoAlterado"
				:button-close-hidden="true"
				:disabledBackgoundClose="true"
			>
				<p>O prazo foi alterado</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<vs-button
							class="w-64 mr-4"
							color="primary"
							type="flat"
							@click="prazoAlterado"
							>Ir para prazos</vs-button
						>

						<vs-button
							class="w-64"
							color="primary"
							type="filled"
							@click="continuarEditando"
							>Continuar editando</vs-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				:title="
					prazo && prazo.desativado
						? 'Ativação de prazo'
						: 'Desativação de prazo'
				"
				:active.sync="popupDesativarPrazo"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja
					{{ prazo && prazo.desativado ? "ativar" : "desativar" }}
					o prazo?
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							class="w-15 mr-4"
							color="dark"
							type="flat"
							@click="popupDesativarPrazo = false"
							>Cancelar</ld-button
						>

						<ld-button
							buttonType="submit"
							class="w-20"
							:color="
								prazo && prazo.desativado ? 'success' : 'danger'
							"
							type="filled"
							@click="desativacaoPrazo"
							>{{
								prazo && prazo.desativado
									? "Ativar"
									: "Desativar"
							}}</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Dar ciência"
				:active.sync="popupDarCienciaPrazo"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja dar ciência no prazo?
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							class="w-15 mr-4"
							color="dark"
							type="flat"
							@click="popupDarCienciaPrazo = false"
							>Cancelar</ld-button
						>

						<ld-button
							buttonType="submit"
							class="w-20"
							color="success"
							type="filled"
							@click="darCiencia"
							>Dar ciência</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Finalização de prazo"
				:active.sync="popupFinalizarPrazo"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja finalizar o prazo?
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							class="w-15 mr-4"
							color="dark"
							type="flat"
							@click="popupFinalizarPrazo = false"
							>Cancelar</ld-button
						>

						<ld-button
							buttonType="submit"
							class="w-20"
							color="success"
							type="filled"
							@click="finalizarPrazo"
							>Finalizar</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Dar prazo como cumprido"
				:active.sync="popupCumprirPrazo"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja dar o prazo como cumprido?
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							class="w-15 mr-4"
							color="dark"
							type="flat"
							@click="popupCumprirPrazo = false"
							>Cancelar</ld-button
						>

						<ld-button
							buttonType="submit"
							class="w-20"
							color="primary"
							type="filled"
							@click="darComoCumprido"
							>Dar como cumprido</ld-button
						>
					</div>
				</div>
			</ld-popup>

			<ld-popup
				title="Reabrir prazo"
				:active.sync="popupReabrirPrazo"
				:button-close-hidden="true"
			>
				<p>
					Tem certeza que deseja reabrir o prazo?
				</p>

				<vs-divider />

				<div class="button-container">
					<div class="button-group flex justify-end">
						<ld-button
							class="w-15 mr-4"
							color="dark"
							type="flat"
							@click="popupReabrirPrazo = false"
							>Cancelar</ld-button
						>

						<ld-button
							buttonType="submit"
							class="w-20"
							color="primary"
							type="filled"
							@click="reabrir"
							>Reabrir</ld-button
						>
					</div>
				</div>
			</ld-popup>
		</ld-popup>

		<ld-popup
			title="Prazo alterado"
			:active.sync="popupPrazoEditado"
			:button-close-hidden="true"
			:disabledBackgoundClose="true"
		>
			<p>
				O prazo foi alterado.
			</p>

			<vs-divider />

			<div class="button-container">
				<div class="button-group flex justify-end">
					<vs-button
						class="w-32"
						color="primary"
						type="filled"
						@click="prazoEditado"
						>OK</vs-button
					>
				</div>
			</div>
		</ld-popup>

		<ld-popup
				title="Duplicar prazo"
				:active.sync="popupDuplicarPrazo"
				:button-close-hidden="true"
			>
				<div class="duplicar-modal">
					<p class="mb-4">
						Quantos prazos você deseja criar?
					</p>

					<vs-input
						v-model="quantidadeDuplicatas"
						label="Quantos prazos"
						type="number"
						min="1"
						max="50"
						class="w-full mb-4"
					/>


					<vs-divider />

					<div class="button-container">
						<div class="button-group flex justify-end">
							<ld-button
								class="w-15"
								color="dark"
								type="flat"
								@click="popupDuplicarPrazo = false"
								>Cancelar</ld-button
							>

							<ld-button
								buttonType="submit"
								class="w-20 mr-4"
								type="filled"
								@click="duplicarPrazo"
								:disabled="!quantidadeDuplicatas || quantidadeDuplicatas <= 0"
								>Duplicar</ld-button
							>
						</div>
					</div>
				</div>
			</ld-popup>
	</div>
</template>

<script>
import Historico from "../../prazo/historico/Historico";
import Geral from "../../prazo/geral/Geral";
import Datas from "../../prazo/datas/Datas";
import Partes from "../../prazo/partes/Partes";
import ErrorHelper from "../../../../../../helpers/ErrorHelper";
import DateHelper from "../../../../../../helpers/DateHelper";
import Prazo from "../../../../../../models/Prazo";
import Empresa from "../../../../../../models/Empresa";

import moment from "moment";
import Usuario from '../../../../../../models/Usuario';
import EncryptHelper from '../../../../../../helpers/EncryptHelper';
import StringHelper from '../../../../../../helpers/StringHelper';

export default {
	name: "PopupEditarPrazo",
		data() {
		return {
			registros: null,
			prazo: null,
			empresa: null,
			partes: null,
			popupDuplicarPrazo: false,
			popupPrazoDesativado: false,
			popupDesativarPrazo: false,
			popupCancelarEdicao: false,
			popupPrazoEditado: false,
			popupDarCienciaPrazo: false,
			popupFinalizarPrazo: false,
			popupCumprirPrazo: false,
			popupReabrirPrazo: false,
			popupPrazoAlterado: false,
			popupAnexosExistentesSalvarAlteracao: false,
			popupAnexosExistentesSair: false,
			atualizarHistorico: {atualizar: false},
			idPopupEditarPrazo: 'id' + StringHelper.alphanumericOnly(EncryptHelper.encrypt("idPopupEditarPrazo")),
			idFormEditarPrazo: 'id' + StringHelper.alphanumericOnly(EncryptHelper.encrypt("idFormEditarPrazo")),
			quantidadeDuplicatas: 1,
				// Apenas duplicação sequencial (sem opções B/C no modal)
		};
	},
	components: {
		Geral,
		Historico,
		Datas,
		Partes
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		prazoPk: {
			required: true
		},
		closed: {
			type: Function,
			required: false
		},
		duplicate: {
			type: Function,
			required: false
		},
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		activePopup: {
			set(value) {
				this.$emit("update:active", value);
			},
			get() {
				return this.active;
			}
		},
		responsavelPk: {
			get() {
				if (!this.prazo || !this.prazo.responsavel) {
					return null;
				}
				return this.prazo.responsavel.pk || null;
			},
			set(value) {
				if (!this.prazo) return;
				if (value) {
					this.prazo.responsavel = new Usuario({ pk: value });
				} else {
					this.prazo.responsavel = new Usuario({});
				}
			}
		},
		supervisorPk: {
			get() {
				if (!this.prazo || !this.prazo.supervisor) {
					return null;
				}
				return this.prazo.supervisor.pk || null;
			},
			set(value) {
				if (!this.prazo) return;
				if (value) {
					this.prazo.supervisor = new Usuario({ pk: value });
				} else {
					this.prazo.supervisor = new Usuario({});
				}
			}
		},
		diasAlerta() {
			if (this.prazo) {
				const dataFinal = moment(this.prazo.endDate)
				const hoje = moment(new Date());
				return dataFinal.diff(hoje, 'days');
			}
			return null;
		},
		isPrazoPerdido() {
			return this.prazo && this.prazo.situacao == 'PERDIDO' && !this.$permissions.can('prazomodificar_perdido') && !this.$permissions.can('autenticadosuperuser');
		}
	},
	methods: {
		async duplicarPrazo() {
			if (!this.quantidadeDuplicatas || this.quantidadeDuplicatas <= 0) {
				this.$vs.notify({
					title: 'Erro',
					text: 'Informe quantos prazos deseja criar',
					color: 'danger',
					time: 3000
				});
				return;
			}

			// Se quantidade = 1, usar rotina antiga
			if (this.quantidadeDuplicatas === 1) {
				this.popupDuplicarPrazo = false;
				this.cancelarEdicao();
				if (this.duplicate) {
					this.prazo.anexos = await this.getAnexos();
					this.duplicate(this.prazo);
				}
				return;
			}

			// Se quantidade > 1, usar nova rotina
			const loading = this.$vsloading({
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Prazo.duplicarLote(this.empresaPk, {
					prazo_id: this.prazoPk,
					quantidade: this.quantidadeDuplicatas
				});

				this.popupDuplicarPrazo = false;
				
				this.$vs.notify({
					title: 'Sucesso',
					text: `${this.quantidadeDuplicatas} prazos duplicados com sucesso!`,
					color: 'success',
					time: 4000
				});

				// Atualizar tabela/listagem se existir callback
				if (this.closed) {
					this.closed();
				}

				setTimeout(() => {
					this.cancelarEdicao();
				}, 500);
			} catch (error) {
				// Extrair mensagem de erro do backend
				let errorMessage = 'Erro ao duplicar prazos';
				if (error && typeof error === 'object') {
					if (error.erro) {
						errorMessage = error.erro;
					} else if (error.message) {
						errorMessage = error.message;
					} else if (error.detail) {
						errorMessage = error.detail;
					} else if (typeof error === 'string') {
						errorMessage = error;
					}
				} else if (typeof error === 'string') {
					errorMessage = error;
				}
				
				this.$vs.notify({
					title: 'Erro',
					text: errorMessage,
					color: 'danger',
					time: 5000
				});
			} finally {
				setTimeout(loading.hide, 200);
			}
		},
		async getAnexos() {

			const loadingAnexos = this.$vsloading({
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {


				const { anexos } = await Prazo.anexos(
					this.empresaPk,
					this.prazoPk,
				);

				return anexos;
			} catch (error) {
				console.error(error);
			} finally {
				setTimeout(loadingAnexos.hide, 200);
			}

			return [];
		},
		async getPrazo() {
			if (this.prazoPk && this.empresaPk) {
				const prazo = await Prazo.getPrazo(this.empresaPk, this.prazoPk);

				this.prazo = {
					...prazo,
					dataInicio: DateHelper.convertDate(
						prazo.dataInicio,
						null,
						"DD/MM/YYYY"
					),
					dataFim: DateHelper.convertDate(
						prazo.dataFim,
						null,
						"DD/MM/YYYY"
					),
					diasUteis: prazo.diasUteis ? "true" : "false",
					responsavel: prazo.responsavel
						? prazo.responsavel
						: new Usuario({}),
					supervisor: prazo.supervisor
						? prazo.supervisor
						: new Usuario({}),
					anexos: prazo.anexos ? prazo.anexos : [],
				};


			}
		},
		async editarPrazo() {
			const loadingEditarPrazo = this.$vsloading({
				container: `#${this.idPopupEditarPrazo}`,
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				this.popupAnexosExistentesSalvarAlteracao = false;

				await Prazo.editar({
					...this.prazo,
					partes: this.getPartes()
				}, this.empresaPk);

				setTimeout(() => {
					loadingEditarPrazo.hide();
					this.popupPrazoEditado = true;
				}, 500);
			} catch (error) {
				ErrorHelper.renderFormError(`#${this.idFormEditarPrazo}`, error);
				loadingEditarPrazo.hide();
			}
		},
		getPartes() {
			let partes = null;

			if (this.prazo.partes && this.partes) {
				const partesEdit = this.prazo.partes.map(parte => parte.nome.trim()).join(",");
				const partesCopia = this.partes.map(parte => parte.nome.trim()).join(",");

				if (partesEdit != partesCopia) {
					partes = this.prazo.partes;
				}
			}

			return partes;
		},
		cancelarEdicao() {
			this.popupAnexosExistentesSair = false;
			this.popupCancelarEdicao = false;
			this.activePopup = false;
		},
		prazoEditado() {
			this.popupPrazoEditado = false;
			this.activePopup = false;
		},
		funcaoFechar() {
			if (this.closed) {
				this.closed();
			}

			const form = document.querySelector(`#${this.idFormEditarPrazo}`);
			ErrorHelper.cleanFormErrors(form);
		},
		async getEmpresa() {
			if (this.empresaPk) {
				const empresa = await Empresa.getEmpresa(this.empresaPk);
				this.empresa = empresa;
			}
		},
		async desativacaoPrazo() {
			this.popupDesativarPrazo = false;

			const loadingDesativacaoPrazo = this.$vsloading({
				container: `#${this.idPopupEditarPrazo}`,
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Prazo.desativar(
					this.empresaPk,
					this.prazo.pk,
					!this.prazo.desativado
				);

				// this.prazo.desativado = !this.prazo.desativado;
				this.popupPrazoDesativado = true;

			} catch (error) {
				ErrorHelper.renderFormError(`#${this.idFormEditarPrazo}`, error);
			} finally {
				loadingDesativacaoPrazo.hide();
			}
		},
		async finalizarPrazo() {
			this.popupFinalizarPrazo = false;

			const loadingPrazo = this.$vsloading({
				container: `#${this.idPopupEditarPrazo}`,
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Prazo.finalizar(
					this.empresaPk,
					this.prazo.pk,
				);

				// this.prazo.finalizado = true;
				this.popupPrazoAlterado = true;

			} catch (error) {
				ErrorHelper.renderFormError(`#${this.idFormEditarPrazo}`, error);
			} finally {
				loadingPrazo.hide();
			}
		},
		async darComoCumprido() {
			this.popupCumprirPrazo = false;

			const loadingPrazo = this.$vsloading({
				container: `#${this.idPopupEditarPrazo}`,
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Prazo.darComoCumprido(
					this.empresaPk,
					this.prazo.pk,
				);

				// this.prazo.cumprido = true;
				this.popupPrazoAlterado = true;

			} catch (error) {
				ErrorHelper.renderFormError(`#${this.idFormEditarPrazo}`, error);
			} finally {
				loadingPrazo.hide();
			}
		},
		async darCiencia() {
			this.popupDarCienciaPrazo = false;

			const loadingPrazo = this.$vsloading({
				container: `#${this.idPopupEditarPrazo}`,
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Prazo.darCiencia(
					this.empresaPk,
					this.prazo.pk,
				);

				// this.prazo.ciente = true;
				this.popupPrazoAlterado = true;

			} catch (error) {
				ErrorHelper.renderFormError(`#${this.idFormEditarPrazo}`, error);
			} finally {
				loadingPrazo.hide();
			}
		},
		async reabrir() {
			this.popupReabrirPrazo = false;

			const loadingPrazo = this.$vsloading({
				container: `#${this.idPopupEditarPrazo}`,
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Prazo.reabrir(
					this.empresaPk,
					this.prazo.pk,
				);

				// this.prazo.cumprido = false;
				// this.prazo.finalizado = false;
				this.popupPrazoAlterado = true;

			} catch (error) {
				ErrorHelper.renderFormError(`#${this.idFormEditarPrazo}`, error);
			} finally {
				loadingPrazo.hide();
			}
		},
		desativacaoFinalizada() {
			if (this.prazo && this.prazo.anexos && this.prazo.anexos.length) {
				this.popupPrazoDesativado = false;
				this.popupAnexosExistentesSair = true;
			} else {
				this.popupPrazoDesativado = false;
				this.activePopup = false;
			}
		},
		prazoAlterado() {
			if (this.prazo && this.prazo.anexos && this.prazo.anexos.length) {
				this.popupPrazoAlterado = false;
				this.popupAnexosExistentesSair = true;
			} else {
				this.popupPrazoAlterado = false;
				this.activePopup = false;
			}
		},
		continuarEditando() {
			this.popupPrazoAlterado = false;
			this.popupPrazoDesativado = false;
			this.atualizarHistorico = {atualizar: true};
			this.getPrazo();
		},
		setPartes() {
			this.partes = JSON.parse(JSON.stringify(this.prazo.partes));
		},
		async getHistorico() {
			const { historico } = await Prazo.getHistorico(this.empresaPk, this.prazoPk, {limit: 20});
			this.registros = historico;
		},
	},
	watch: {
		active() {
			if (this.active) {
				this.prazo = null;
				this.registros = null;

			const loading = this.$vsloading({
				container: `#${this.idPopupEditarPrazo}`,
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			Promise.all([this.getPrazo(), this.getEmpresa(), this.getHistorico()])
				.then(() => {
					this.setPartes();
				})
				.catch(error => {
					console.error(error);
				})
				.finally(() => {
					loading.hide();
				});
			}
		}
	},
};
</script>

<style lang="scss" src="./popup_editar_prazo_global.scss"></style>
<style lang="scss" scoped src="./popup_editar_prazo.scss"></style>
